import { createApp } from "vue";
import { AlertTriangle, Banknote, ChevronDown, ChevronUp, CreditCard, ExternalLink, FolderPlus, History, List, LogOut, Monitor, RefreshCw, RotateCw, Store, ToggleLeft, ToggleRight, Trash2, UploadCloud, UserCircle, Users, WalletCards } from "lucide-vue-next";
import { createVueUi } from "@lunagoai/vue-ui";
import "@lunagoai/vue-ui/style.css";
import AdminApp from "./AdminApp.vue";
import "./assets/main.css";
import { installPreloadRecovery, registerPwa } from "./lib/pwa";
import { posnextVueUiTheme } from "./lib/vue-ui-theme";

installPreloadRecovery();
createApp(AdminApp).use(createVueUi({ icons: { AlertTriangle, Banknote, ChevronDown, ChevronUp, CreditCard, ExternalLink, FolderPlus, History, List, LogOut, Monitor, RefreshCw, RotateCw, Store, ToggleLeft, ToggleRight, Trash2, UploadCloud, UserCircle, Users, WalletCards }, theme: posnextVueUiTheme })).mount("#app");
registerPwa("/admin-sw.js");
